module.exports = __webpack_public_path__ + "img/teammodel_title.d0371f3d.png";